import { CombineComponents } from "../components/CombineComponents";
import { AuthProvider } from "../context/AuthContext";
import { LoadingProvider } from "../context/LoadingContext";
import { LanguageProvider } from "../context/LanguageContext";
import { AlertProvider } from "../context/AlertContext";
import { WebsiteNameProvider } from "../context/WebsiteNameContext";

const AppContextProvider = CombineComponents([
  AuthProvider,
  WebsiteNameProvider,
  LoadingProvider,
  LanguageProvider,
  AlertProvider
]);

export default AppContextProvider;
